import ApiService from '@/services/apiService'
import TokenService from '@/services/storageService'

class AuthenticationError extends Error {
	constructor(errorCode, message) {
		super(message)
		this.name = this.constructor.name
		this.message = message
		this.errorCode = errorCode
	}
}

const UserService = {

	refreshTokenInterval: null,

	/**
	 * Save tokens, add authorization and 401 interceptors
	 */
	setAuth(token) {
		TokenService.saveToken(token)
		ApiService.setHeader()
		ApiService.mount401Interceptor()
	},

	/**
     * Login the user and store the access token to TokenService
     **/
	login: async function (email, password) {
		const requestData = {
			method: 'post',
			url: "/auth/login",
			data: { email, password }
		}
		try {
			const response = await ApiService.customRequest(requestData)
			this.setAuth(response.access_token)
			console.log('userService login complete')
			return response
		} catch (error) {
			console.log('userService login error :>>', { error })
			throw new AuthenticationError(error.response.status, error.message)
		}
	},

	/**
	 * Register a new user and store the access token to TokenService
	 */
	register: async function ({ first_name, last_name, email, phone, password }) {
		const resource = 'auth/register'
		try {
			const response = await ApiService.post(resource, { first_name, last_name, email, phone, password })
			this.setAuth(response.access_token)
			return response
		} catch (error) {
			throw new AuthenticationError(error.response.status, error.response.data.detail)
		}
	},

	/**
	 * Submit email to get a password retrieval
	 */
	forgotPassword: async function (payload) {
		const resource = 'auth/passwords/reset/step-one'
		try {
			const response = await ApiService.post(resource, payload)
			return response.data
		} catch (error) {
			// Email not in system
			if (error.response.status === 401)
				return error.response.data
			// Invalid request type (not an email, etc)
			if (error.response.status === 422)
				throw new AuthenticationError(error.response.status, error.response.data.detail)
		}
	},

	/**
     * Logout the current user by removing the token from storage. 
     * Will also remove `Authorization Bearer <token>` header from future requests.
    **/
	logout() {
		TokenService.removeToken()
		TokenService.removeRefreshToken()
		ApiService.removeHeader()
		ApiService.unmount401Interceptor()
		clearInterval(this.refreshTokenInterval)
		console.log('userService logout complete')
	},

	setRefreshTokenInterval() {
		this.refreshTokenInterval = setInterval(async () => {
			try {
				const response = await ApiService.get("refresh-token")
				console.log('userService refreshTokenInterval response :>> ', response);
				return response
			} catch (error) {
				console.log({ error })
				if (error.response.status === 422)
					throw new AuthenticationError(error.response.status, error.response.data.detail)
				// if (error.error === 'token_expired' || error.error === 'token_invalid')
				this.logout()
			}
		}, 3600000) // one hour - for science
	},

	async getUser() {
		const resource = 'auth/me'
		try {
			const response = await ApiService.get(resource)
			return response
		} catch (error) {
			console.log(false)
			return false
		}
	}
}

export default UserService
export { UserService, AuthenticationError }
